import FeaturesItem from "components/MainPage/FeaturesItem";
import shieldIcon from "assets/icons/shield-icon.svg";
import elasticIcon from "assets/icons/idea.svg";
import premiumQualityIcon from "assets/icons/premium-quality.svg";
import userSupportIcon from "assets/icons/customer-support.svg";
import applicationIcon from "assets/icons/stretch-wrapping.svg";
import partnershipIcon from "assets/icons/partnership-icon.svg";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import { useScreenSize } from "utils/hooks/useScreenSize";

export type FeatureItemType = {
	id: string,
	image: string
}

const features: FeatureItemType[] = [
	{
		id: "protection",
		image: shieldIcon,
	},
	{
		id: "userSupport",
		image: userSupportIcon,
	},
	{
		id: "partnership",
		image: partnershipIcon,
	},
	{
		id: "application",
		image: applicationIcon,
	},
	{
		id: "elastic",
		image: elasticIcon,
	},
	{
		id: "quality",
		image: premiumQualityIcon,
	},
];

function Features() {
	const screenSize = useScreenSize();

	return (
		<div className="features container">
			<div className="features__wrapper features__wrapper--desktop">
				{
					features.map(({ image, id }, index) =>
						<FeaturesItem
							key={ index }
							image={ image }
							id={ id }
						/>,
					)
				}
			</div>
			<div className="features__wrapper features__wrapper--mobile">
				<Swiper
					spaceBetween={ 50 }
					modules={ [ Pagination, Autoplay ] }
					slidesPerView={ screenSize.width > 768 ? 2 : 1 }
					pagination={ { clickable: true } }
					autoplay={ { delay: 2000, pauseOnMouseEnter: true } }
					loop={ true }
				>
					{
						features.map(({ image, id }, index) =>
							<SwiperSlide key={ index }>
								<FeaturesItem
									image={ image }
									id={ id }
								/>
							</SwiperSlide>,
						)
					}
				</Swiper>
			</div>
		</div>
	);
}

export default Features;